<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <recargo-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import RecargoShowData from "./RecargoShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "RecargoShow",
        components: {CrudShow, RecargoShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'recargo.showing',
            }
        },
    }
</script>
